export default function (Component) {
Component.options.__title = "`v-model` Example"
}